module.exports = require('./browser/algorithms.json')



//////////////////
// WEBPACK FOOTER
// ../~/browserify-sign/algos.js
// module id = ../node_modules/browserify-sign/algos.js
// module chunks = 0